import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserDataService } from './user-data.service';
import { endpoints } from '../constants/Endpoints';

export interface CompanyContext {
  is_impersonating: boolean;
  base_company_id: number | null;
  impersonated_company_id: number | null;
}

@Injectable({ providedIn: 'root' })
export class CompanyContextService {
  private http = inject(HttpClient);
  private userDataS = inject(UserDataService);

  private _isImpersonating = new BehaviorSubject<boolean>(false);
  private _baseCompanyId = new BehaviorSubject<number | null>(null);
  private _impersonatedCompanyId = new BehaviorSubject<number | null>(null);

  isImpersonating$ = this._isImpersonating.asObservable();
  baseCompanyId$ = this._baseCompanyId.asObservable();
  impersonatedCompanyId$ = this._impersonatedCompanyId.asObservable();

  get isImpersonating() {
    return this._isImpersonating.value;
  }
  get baseCompanyId() {
    return this._baseCompanyId.value;
  }
  get impersonatedCompanyId() {
    return this._impersonatedCompanyId.value;
  }

  constructor() {
    this.userDataS.onEinaDataChange.subscribe((whoami) => {
      console.log('CompanyContextService received whoami change', whoami);
      this.loadFromWhoami(whoami?.context);
    });

    // Si ya hay datos cargados, inicializar AHORA
    if (this.userDataS.hasData) {
      this.loadFromWhoami(this.userDataS.whoami?.context);
    }
  }

  loadFromWhoami(context?: CompanyContext) {
    if (!context) return;
    this._isImpersonating.next(context.is_impersonating ?? false);
    this._baseCompanyId.next(context.base_company_id ?? null);
    this._impersonatedCompanyId.next(context.impersonated_company_id ?? null);
  }

  impersonateCompany(companyId: number): Promise<Object> {
    const url = endpoints.impersonate.url;
    const result = firstValueFrom(this.http.post(url, {company_id: companyId}));
    this.userDataS.getUserData(true);
    return result;
  }

  async leaveCompany(): Promise<any> {
    const url = endpoints.leave.url;
    const result = await firstValueFrom(this.http.post(url, {}));
    await this.userDataS.getUserData(true);
    return result;
  }
}
